<template>
  <BaseLayout>
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12 sm12 lg9>
          <v-card>
            <v-card-title class="headline pb-2">
              <v-layout wrap>
                <v-flex xs12>
                  {{ session.title }}
                </v-flex>
                <v-flex xs12 pt-2 v-if="$isSuperuser()">
                  <PublishedChip :value="session" />
                </v-flex>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <table>
                <tr>
                  <th class="text-xs-left pr-4">Datum</th>
                  <td>{{ session.date | toLocaleDateString }}</td>
                </tr>
                <tr v-if="$isSuperuser()">
                  <th class="text-xs-left pr-4">Veröffentlicht per</th>
                  <td>
                    {{ session.publishing_datetime | toLocaleDateTimeString }}
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left pr-4">Traktandenliste</th>
                  <td>
                    <a v-if="session.agenda" @click="session.agenda.download()"
                       href="javascript:;">
                      {{ session.agenda.name }} ({{ session.agenda.size }})
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>
                <tr>
                  <th class="text-xs-left pr-4">Protokoll</th>
                  <td>
                    <a v-if="session.protocol" @click="session.protocol.download()"
                       href="javascript:;">
                      Grossratsprotokoll vom {{ session.date | toLocaleDateString }}
                      ({{ session.protocol.size }})
                    </a>
                    <span v-else>-</span>
                  </td>
                </tr>
              </table>
            </v-card-text>
            <v-card-actions>
              <template v-if="$isSuperuser()">
                <v-btn
                  @click="$showNotificationDialog"
                  depressed
                >Benachrichtigen</v-btn>
                <v-btn
                  :to="session.editURL"
                  depressed
                >Bearbeiten</v-btn>
                <v-btn
                  @click="destroy"
                  color="red"
                  depressed
                  dark
                >Löschen</v-btn>
              </template>
              <v-spacer />
              <v-btn
                depressed
                @click="downloadZip"
                :loading="zipLoading">
                <v-icon
                  class="ml-0"
                  left
                  right>
                  cloud_download
                </v-icon>
                Alle Dokumente
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout justify-center>
        <v-flex xs12 sm12 lg9>
          <v-card>
            <v-card-title class="title">
              Traktandierte Geschäfte
            </v-card-title>
            <v-card-text>
              <BusinessTable
                :businesses="session.businessesRelation"
              ></BusinessTable>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </BaseLayout>
</template>

<script>
import File from '@/models/file';
import Session from '@/models/session';
import { confirmedDestroy } from '@/helpers/utils';

export default {
  name: 'ShowSession',
  async asyncData({ id }) {
    await Promise.all([
      Session.findOrFetch(id),
      Session.fetchRelated('businesses', id),
      File.fetchAll(),
    ]);
  },
  data() {
    return {
      session: Session.query().with('businessesRelation').find(this.$route.params.id),
      zipLoading: false,
    };
  },
  methods: {
    async destroy() {
      if (await confirmedDestroy(this.session)) {
        this.$router.push({ name: 'sessions' });
      }
    },

    async downloadZip() {
      try {
        this.zipLoading = true;
        await this.session.downloadZip();
      } finally {
        this.zipLoading = false;
      }
    },
  },
};
</script>
